import { Typography, Box, Skeleton } from '@mui/material';
import React from 'react';
import { useGetControlLocationStatusQuery } from 'services/control.service';
import { IGatewayType } from 'services/gateway.service';
import { ControlLocationDetailStatusType, ControlLocationType } from 'state/modules/control/controlReducer';
import styled from '@emotion/styled';
import PinIcon from '../../assets/icons/pin-icon.svg';
import WaveIcon0 from '../../assets/icons/wave-icon-0.svg';
import WaveIcon1 from '../../assets/icons/wave-icon-1.svg';
import WaveIcon2 from '../../assets/icons/wave-icon-2.svg';
import WaveIcon3 from '../../assets/icons/wave-icon-3.svg';
import WaveIcon4 from '../../assets/icons/wave-icon-4.svg';
import PowerIcon from '../../assets/icons/power.svg';
const waveList = [WaveIcon0, WaveIcon1, WaveIcon2, WaveIcon3, WaveIcon4];

const BatteryBarContainer = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'percentage',
})<{ percentage: number }>(({ percentage }) => ({
  width: '20px',
  height: '10px',
  border: `1.5px solid ${percentage > 20 ? '#9be89b' : '#FAD4A2'}`,
  borderRadius: '2.5px',
  position: 'relative',
  backgroundColor: '#ffffff',
  display: 'flex',
  alignItems: 'center',
  padding: '1px',
  boxSizing: 'border-box',
  marginLeft: '4px',
}));

const BatteryBarFill = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'percentage',
})<{ percentage: number }>(({ percentage }) => ({
  width: `${percentage}%`,
  height: '100%',
  borderRadius: '1.5px',
  backgroundColor: percentage > 20 ? '#09d029' : '#F2994A',
  transition: 'width 0.3s ease-in-out',
}));

const BatteryTip = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'percentage',
})<{ percentage: number }>(({ percentage }) => ({
  position: 'absolute',
  right: '-3px',
  top: '50%',
  transform: 'translateY(-50%)',
  width: '1.5px',
  height: '4px',
  backgroundColor: percentage > 20 ? '#9be89b' : '#FAD4A2',
  borderRadius: '1px',
}));

const ChargingIcon = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'percentage',
})<{ percentage: boolean }>(({ percentage }) => ({
  position: 'absolute',
  width: '6px',
  height: '10px',
  top: '46%',                  
  right: '8px',                 
  transform: 'translateY(-50%)', 
  display: percentage ? 'block' : 'none',
  zIndex: 1,
}));

export const MakerHover = ({
  gatewayTypes,
  location,
  agencyId,
}: {
  gatewayTypes: IGatewayType[];
  location: ControlLocationType;
  agencyId: string;
}) => {
  const { data, isLoading } = useGetControlLocationStatusQuery<{
    data?: ControlLocationDetailStatusType;
    isLoading: boolean;
  }>({
    agencyId,
    locationId: location.id,
  });
  const gatewayType = gatewayTypes ? gatewayTypes.find((item: any) => item.id === data?.gateway.type_id) : null;

  return (
    <Box
      style={{
        width: '220px',
        height: 'auto',
        border: '1px solid #dadde9',
        left: '20px',
        top: '-20px',
        backgroundColor: '#fff',
        textAlign: 'left',
        borderRadius: '8px',
        padding: '12px 16px',
        position: 'absolute',
        zIndex: 1,
      }}
    >
      <Typography style={{ fontSize: '16px', fontWeight: 600, color: '#1E2323' }}>{location.name}</Typography>
      {isLoading ? (
        <>
          <Box display="flex" alignItems="center" py={'4px'}>
            <Skeleton variant="text" sx={{ fontSize: '1rem', width: '100%' }} />
          </Box>
          <Box display="flex" alignItems="center" py={'4px'}>
            <Skeleton variant="text" sx={{ fontSize: '1rem', width: '100%' }} />
          </Box>
          <Box display="flex" alignItems="center" pt={'4px'}>
            <Skeleton variant="text" sx={{ fontSize: '1rem', width: '100%' }} />
          </Box>
        </>
      ) : (
        <>
          <Box display="flex" alignItems="center" py={'4px'}>
            <Typography style={{ fontSize: '13px', color: '#8B8C9B', marginRight: '4px' }}>Loại:</Typography>
            <Typography style={{ fontSize: '13px', color: '#52535C' }}>{gatewayType?.name || '--'}</Typography>
          </Box>
          <Box display="flex" alignItems="center" py={'4px'}>
            <Typography style={{ fontSize: '13px', color: '#8B8C9B', marginRight: '4px' }}>Serial:</Typography>
            <Typography style={{ fontSize: '13px', color: '#52535C' }}>{data?.gateway.serial || '--'}</Typography>
          </Box>
          <Box display="flex" alignItems="center" pt={'4px'}>
            <Box display="flex" alignItems="center">
              <Typography style={{ color: '#52535C', fontSize: '13px', paddingBottom: '2px' }}>
                {data?.gateway.state?.battery || 0}%
              </Typography>
              <BatteryBarContainer percentage={data?.gateway.state?.battery || 0}>
                <BatteryBarFill percentage={data?.gateway.state?.battery || 0} />
                <BatteryTip percentage={data?.gateway.state?.battery || 0} />
                <ChargingIcon percentage={data?.gateway.state?.charge === 1}>
                  <img src={PowerIcon} alt="Charging" style={{ width: '100%', height: '100%' }} />
                </ChargingIcon>
              </BatteryBarContainer>
            </Box>
            <Box ml={2} display="flex" alignItems="flex-end">
              <img
                src={waveList[data?.gateway.state?.gsmLevel || 0]}
                alt=""
                style={{ width: '24px', height: '24px' }}
              />
            </Box>
          </Box>
        </>
      )}
    </Box>
  );
};
